<template>
	<v-dialog v-model="dialogExcluir" scrollable persistent max-width="400">
		<v-card class="pa-8 rounded-xl" max-width="400">
			Você realmente deseja excluir esse produto?
			<v-row class="pt-0">
				<v-col cols="6"  class="pb-0">
					<Botao @clicar="excluirProduto()" texto="Excluir" transparente/>
				</v-col>
				<v-col cols="6" class="pb-0">
					<Botao @clicar="dialogClose()" texto="Cancelar"/>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import Botao from '../shared/Botao.vue'
export default {
	props: {
		dialog: Boolean,
		id: String,
	},
	components: {
		Botao,
	},
	computed: {
		dialogExcluir: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		...mapActions({ delToCart: 'delToCart' }),
		dialogClose() {
			this.$emit('dialogClose')
		},
		excluirProduto() {
			const cart = { uuid: this.id }
			this.delToCart(cart)
			this.dialogClose()
		},
	},
}
</script>

<style scoped>
.botao {
	width: 100%;
}
</style>
